import React from 'react';
import { OutlinedEditFilter } from '@hose/eui-icons';
import StaffFilter from '../../data-grid/StaffFilter';
var getColumnStaff = function (cellRender) {
    return {
        filterDropdown: function (_a) {
            var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
            return (React.createElement(StaffFilterDropdown, { clearFilters: clearFilters, setSelectedKeys: setSelectedKeys, confirm: confirm, selectedKeys: selectedKeys }));
        },
        filterIcon: function () { return React.createElement(OutlinedEditFilter, { fontSize: 16, style: { color: 'var(--eui-icon-n2)' } }); },
        render: cellRender
    };
};
var StaffFilterDropdown = function (_a) {
    var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
    var handleChange = function (value) {
        setSelectedKeys(value);
    };
    var handleConfirm = function () {
        confirm();
    };
    var handleReset = function () {
        setSelectedKeys(undefined);
        clearFilters({ confirm: true, closeDropdown: true });
    };
    return React.createElement(StaffFilter, { value: selectedKeys, onChange: handleChange, onOk: handleConfirm, onReset: handleReset });
};
export default getColumnStaff;
